import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type ComplianceStatus = "compliant" | "warning" | "non-compliant";

interface ComplianceCardProps {
  title: string;
  description: string;
  status: ComplianceStatus;
  lastUpdated?: string;
  className?: string;
}

const statusConfig = {
  compliant: {
    label: "Compliant",
    className: "bg-compliant text-compliant-foreground",
  },
  warning: {
    label: "Needs Attention",
    className: "bg-warning text-warning-foreground",
  },
  "non-compliant": {
    label: "Non-Compliant",
    className: "bg-non-compliant text-non-compliant-foreground",
  },
};

export function ComplianceCard({ 
  title, 
  description, 
  status, 
  lastUpdated,
  className 
}: ComplianceCardProps) {
  const config = statusConfig[status];

  return (
    <Card className={cn("bg-gradient-card shadow-card transition-all hover:shadow-elevated", className)}>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-semibold">{title}</CardTitle>
          <Badge className={config.className}>
            {config.label}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-sm mb-2">{description}</p>
        {lastUpdated && (
          <p className="text-xs text-muted-foreground">
            Last updated: {lastUpdated}
          </p>
        )}
      </CardContent>
    </Card>
  );
}